import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {faker} from '@faker-js/faker';
import Typography from '@mui/material/Typography';
import {useNavigate} from 'react-router-dom';
import {URLS} from '../../constants/appConstants';

export default function CoinsDetailDialog() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const navigate = useNavigate();


  return (
    <React.Fragment>
      <Typography variant="body1" onClick={handleClickOpen}>
        {faker.number.int({min: 100, max: 1000})}
        <br/>
        Coins
      </Typography>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Coins
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p><b>Balance: {faker.number.int({min: 100, max: 1000})}</b></p>
            <p><b>How can you earn it?</b></p>
            When you interact more in the App, You'll get more points.

            <ul>
              <li>Vote - 1 Coins</li>
              <li>Quiz - 5 Coins</li>
              <li>
                Puzzles
                <ul>
                  <li>Easy - 10 Coins</li>
                  <li>Medium - 25 Coins</li>
                  <li>Hard - 10 Coins</li>
                </ul>
              </li>
            </ul>

            <b>What is the use of coins?</b>
            <ul>
              <li>
                To solve any Questions
              </li>
              <li>
                To <a href='#'>boost</a> your own Questions
              </li>
            </ul>
            View your <Button onClick={navigate(URLS.COINS_DASHBOARD)}>coins Dashboard</Button>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
